import { render, staticRenderFns } from "./LocationReport.vue?vue&type=template&id=4578bc61&"
import script from "./LocationReport.vue?vue&type=script&lang=js&"
export * from "./LocationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports